import { render, staticRenderFns } from "./StoreRoleEdit.vue?vue&type=template&id=5f561140&scoped=true&"
import script from "./StoreRoleEdit.vue?vue&type=script&lang=js&"
export * from "./StoreRoleEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f561140",
  null
  
)

export default component.exports